import React from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles } from "@material-ui/core/styles";

import SubmitButton from "../button/SubmitButton";
import CancelButton from "../button/CancelButton";
import TextField from "../formik/TextField";

import { REGEX_URL } from "../../config";

const useStyles = makeStyles((theme) => ({
  form: {
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    width: "fit-content",
  },
}));

const yupSchema = Yup.object().shape({
  id: Yup.number().required(),
  caption: Yup.string().trim().nullable(),
  description: Yup.string().trim().nullable(),
  isCover: Yup.number().required(),
  status: Yup.number().required(),
  attributionName: Yup.string().trim().nullable(),
  attributionUrl: Yup.string()
    .trim()
    // .url("Must be a URL")
    .matches(REGEX_URL, "Must be a URL")
    .nullable(),
});

export default function MediaEditForm({
  openModal,
  handleCloseModal,
  mediaDetails,
  isSubmitting,
  handleUpdate,
}) {
  const classes = useStyles();

  return (
    <Dialog
      open={openModal}
      onClose={handleCloseModal}
      fullWidth={true}
      maxWidth="sm"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
    >
      <DialogTitle id="alert-dialog-title">Edit Media</DialogTitle>

      <Formik
        initialValues={mediaDetails}
        onSubmit={(values) => {
          handleUpdate(values);
        }}
        validationSchema={yupSchema}
      >
        {(props) => {
          const { touched, errors } = props;
          //console.log(errors);
          return (
            <Form className={classes.form}>
              <DialogContent dividers>
                <Field
                  component={TextField}
                  name="caption"
                  margin="normal"
                  label="Short Description"
                  fullWidth
                  disabled={isSubmitting}
                />
                <Field
                  component={TextField}
                  name="description"
                  margin="normal"
                  label="Description"
                  fullWidth
                  multiline
                  maxRows={100}
                  disabled={isSubmitting}
                />
                <Field
                  component={TextField}
                  name="attributionName"
                  margin="normal"
                  label="Attribution Name"
                  fullWidth
                  disabled={isSubmitting}
                />
                <Field
                  component={TextField}
                  name="attributionUrl"
                  margin="normal"
                  label="Attribution URL"
                  fullWidth
                  helperText={
                    touched.attributionUrl &&
                    errors.attributionUrl &&
                    errors.attributionUrl
                  }
                  error={!!touched.attributionUrl && !!errors.attributionUrl}
                  disabled={isSubmitting}
                />
              </DialogContent>
              <DialogActions style={{ margin: "20px" }}>
                <CancelButton
                  onClick={handleCloseModal}
                  disabled={isSubmitting}
                >
                  Cancel
                </CancelButton>
                <SubmitButton
                  disabled={isSubmitting}
                  isSubmitting={isSubmitting}
                >
                  Update
                </SubmitButton>
              </DialogActions>
            </Form>
          );
        }}
      </Formik>
    </Dialog>
  );
}
